// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import HomepageFilterController from "./homepage_filter_controller"
application.register("homepage-filter", HomepageFilterController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MediaLibraryController from "./media_library_controller"
application.register("media-library", MediaLibraryController)

import OwnerPostsListController from "./owner_posts_list_controller"
application.register("owner-posts-list", OwnerPostsListController)

import OwnerMobileMenuController from "./owner_mobile_menu_controller"
application.register("owner-mobile-menu", OwnerMobileMenuController)

import PaginationScrollController from "./pagination_scroll_controller"
application.register("pagination-scroll", PaginationScrollController)

import PasswordRequirementsController from "./password_requirements_controller"
application.register("password-requirements", PasswordRequirementsController)

import PostMediaTabsController from "./post_media_tabs_controller"
application.register("post-media-tabs", PostMediaTabsController)

import PublicNavMenuController from "./public_nav_menu_controller"
application.register("public-nav-menu", PublicNavMenuController)

import PublicationFormController from "./publication_form_controller"
application.register("publication-form", PublicationFormController)

import RichTextSourceController from "./rich_text_source_controller"
application.register("rich-text-source", RichTextSourceController)

import ResponsiveGalleryController from "./responsive_gallery_controller"
application.register("responsive-gallery", ResponsiveGalleryController)

import SlugSyncController from "./slug_sync_controller"
application.register("slug-sync", SlugSyncController)

import SettingsFormController from "./settings_form_controller"
application.register("settings-form", SettingsFormController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToastStackController from "./toast_stack_controller"
application.register("toast-stack", ToastStackController)

import TurnstileFormController from "./turnstile_form_controller"
application.register("turnstile-form", TurnstileFormController)

import VideoLightboxController from "./video_lightbox_controller"
application.register("video-lightbox", VideoLightboxController)
